/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GET_JOB_ROLE,
  GET_JOB_ROLE_DETAILS,
  GET_JOB_ROLE_SUBMITTED_CANDIDATE_LIST,
} from '../constants/action-types'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ActionTypes } from '../action'
import { JobRoleData } from '../Actions'

const initialState = {
  jobRoles: { count: 0, results: [] },
  isLoading: false,
  jobRoleDetails: null,
  isLoadingJobRoleCandidate: false,
  jobRoleCandidateList: { count: 0, results: [] },
}

const reducer = persistReducer(
  { storage, key: 'basecode-demo', whitelist: ['user'] },
  (state: JobRoleData = initialState, action: ActionTypes) => {
    switch (action.type) {
      case GET_JOB_ROLE.GET_JOB_ROLE_INITIALIZATION:
      case GET_JOB_ROLE_DETAILS.GET_JOB_ROLE_DETAILS_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }
      case GET_JOB_ROLE.GET_JOB_ROLE_FAILED:
      case GET_JOB_ROLE_DETAILS.GET_JOB_ROLE_DETAILS_FAILED:
        return {
          ...state,
          isLoading: false,
        }
      case GET_JOB_ROLE.GET_JOB_ROLE_SUCCESS:
        const jobRoles: any = action.payload
        return {
          ...state,
          isLoading: false,
          jobRoles,
        }
      case GET_JOB_ROLE_DETAILS.GET_JOB_ROLE_DETAILS_SUCCESS:
        const jobRoleDetails: any = action.payload
        return {
          ...state,
          isLoading: false,
          jobRoleDetails,
        }
      case GET_JOB_ROLE_SUBMITTED_CANDIDATE_LIST.JOB_ROLE_SUBMITTED_CANDIDATE_LIST_INITIALIZATION:
        return {
          ...state,
          isLoadingJobRoleCandidate: true,
        }
      case GET_JOB_ROLE_SUBMITTED_CANDIDATE_LIST.JOB_ROLE_SUBMITTED_CANDIDATE_LIST_FAILED:
        return {
          ...state,
          isLoadingJobRoleCandidate: false,
        }
      case GET_JOB_ROLE_SUBMITTED_CANDIDATE_LIST.JOB_ROLE_SUBMITTED_CANDIDATE_LIST_SUCCESS:
        const jobRoleCandidateList: any = action.payload
        return {
          ...state,
          isLoadingJobRoleCandidate: false,
          jobRoleCandidateList,
        }
      default:
        return state
    }
  }
)

export default reducer
